import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import ChurchImage from '../nav logo/church-removebg-preview(1).png';
import ClockImage from '../nav logo/clock-removebg-preview.png';
import MembersBlue from '../nav logo/membersblue-removebg-preview.png';
import PresentImage from '../nav logo/presentimage-removebg-preview.png';
import AbsentImage from '../nav logo/absent-removebg-preview.png';
import GenderImage from '../nav logo/gender.jpg';
import MaleImage from '../nav logo/male.jpg';
import WomenImage from '../nav logo/women.jpg';
import MembersRed from '../nav logo/membersred-removebg-preview.png';
import Layout from './Layout';
import { useTheme } from '../context/ThemeContext';

function Attendance() {
	const { isDark } = useTheme();

	return (
		<Layout title="Attendance Dashboard">
			<div
					className={`flex-grow max-w-screen-2xl mx-auto mr-0 lg:mr-1  transition-colors duration-300 ${
						isDark ? 'bg-gray-900' : ''
					}`}
					style={{ width: '100%', minHeight: '100vh', overflowY: 'auto', marginLeft: 0 }}
				>
					<div
						className={`mt-16 h-auto lg:h-40 p-4 lg:p-10 rounded-t-xl flex flex-col lg:flex-row justify-between ${
							isDark ? 'bg-gradient-to-r from-gray-800 to-gray-900' : 'bg-gradient-to-r from-green-600 to-teal-500'
						}`}
					>
						<div>
							<h1 className="text-white font-bold text-2xl">Attendance Dashboard</h1>
							<p className="text-white text-xs font-semibold">View and manage church attendance records</p>
						</div>
						<div>
							<NavLink to="/markattendance" className="rounded-md text-white font-semibold">
								<h1 className="bg-green-400 shadow-2xl hover:bg-green-600 p-3 hover:shadow-2xl mt-5 text-center rounded-md transition duration-300">
									Mark Attendance
								</h1>
							</NavLink>
						</div>
					</div>

					<div
						className={`shadow-2xl rounded-b-xl p-4 lg:p-6 flex flex-col lg:flex-row justify-between gap-4 text-xs font-bold ${
							isDark ? 'bg-gray-800 text-gray-100' : 'bg-white'
						}`}
					>
						<div className="flex gap-4 flex-wrap">
							<NavLink to="/todayrecord">
								<h1 className={`${isDark ? 'bg-blue-900 text-blue-200' : 'bg-blue-100 text-blue-700'} p-2 rounded-md`}>Today's records</h1>
							</NavLink>
							<NavLink to="/allrecord">
								<h1 className={`p-2 border rounded-md border-gray-400 border-dotted ${isDark ? 'bg-gray-900 text-gray-100' : 'bg-white'}`}>All Records</h1>
							</NavLink>
						</div>
						<div className="flex gap-4 flex-wrap">
							<NavLink><h1 className={`${isDark ? 'bg-green-900 text-green-200' : 'bg-green-100 text-green-700'} p-2 rounded-md`}>Weekly Reports</h1></NavLink>
							<NavLink><h1 className={`${isDark ? 'bg-purple-900 text-purple-200' : 'bg-purple-100 text-purple-700'} p-2 rounded-md`}>Attendance Patterns</h1></NavLink>
							<NavLink><h1 className={`${isDark ? 'bg-blue-900 text-blue-200' : 'bg-blue-100 text-blue-700'} p-2 rounded-md`}>Compare Periods</h1></NavLink>
							<NavLink><h1 className={`${isDark ? 'bg-green-900 text-green-200' : 'bg-green-100 text-green-700'} p-2 rounded-md`}>Goals</h1></NavLink>
							<NavLink><h1 className={`${isDark ? 'bg-red-900 text-red-200' : 'bg-red-100 text-red-700'} p-2 rounded-md`}>Reminders</h1></NavLink>
						</div>
					</div>

					<div className={`shadow-2xl rounded-xl p-4 lg:p-6 flex flex-col lg:flex-row justify-between gap-4 text-xs font-bold mt-6 ${isDark ? 'bg-blue-950 text-gray-100' : 'bg-blue-200'}`}>
						<div className="flex gap-4 flex-1">
							<img src={ChurchImage} alt="" className="w-10 h-10" />
							<div>
								<h1 className={`${isDark ? 'text-white' : 'text-gray-800'} font-bold text-xl`}>Sunday Morning Services</h1>
								<div className="flex gap-3 flex-wrap">
									<p className={`text-xs ${isDark ? 'text-gray-200 bg-gray-800' : 'text-gray-600 bg-white'} p-1 rounded-xl font-semibold w-24 text-center mt-2`}>16 Apr, 2025</p>
									<p className={`text-xs ${isDark ? 'text-gray-200 bg-gray-800' : 'text-gray-600 bg-white'} p-1 rounded-xl font-semibold text-center mt-2`}>Sunday, First Service - 7:00 AM - 9:00 AM</p>
									<p className={`text-xs ${isDark ? 'text-gray-200 bg-gray-800' : 'text-gray-600 bg-white'} p-1 rounded-xl font-semibold text-center mt-2`}>Sunday, Second Service - 9:00 AM - 11:00 AM</p>
								</div>
							</div>
						</div>
						<div className="flex gap-3 flex-shrink-0 mt-4 lg:mt-0">
							<NavLink to="/details"><h1 className="bg-blue-700 p-2 rounded-md text-white font-bold text-xs">Details</h1></NavLink>
							<NavLink to="/edit"><h1 className="bg-green-700 p-2 rounded-md text-white font-bold text-xs">Edit</h1></NavLink>
							<NavLink to="/visitattendance"><h1 className="bg-purple-700 p-2 rounded-md text-white font-bold text-xs">Visit Attendance</h1></NavLink>
						</div>
					</div>

					<div className={`mt-6 shadow-2xl rounded-xl p-4 ${isDark ? 'bg-gray-800' : 'bg-gray-300'}`}>
						<div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
							<h1 className={`${isDark ? 'text-gray-100' : 'text-gray-700'} text-xl font-bold`}>Attendance Summary</h1>
							<p className={`${isDark ? 'bg-gray-900 text-gray-100' : 'bg-white'} rounded-xl p-1 font-semibold text-xs`}>
								<span className="text-green-600 font-bold">30</span> members marked out of <span className="text-blue-700 font-bold">201</span> active members
							</p>
						</div>
						<div className={`${isDark ? 'bg-gray-900' : 'bg-white'} flex flex-col md:flex-row gap-6 mt-6 rounded-xl p-4 items-center`}>
							<div className={`${isDark ? 'bg-blue-900' : 'bg-blue-100'} flex items-center justify-between p-4 w-full md:w-1/4 rounded-xl shadow-lg`}>
								<div className="flex items-center gap-3">
									<img src={MembersBlue} alt="members" className="w-10 h-10" />
									<div>
										<h1 className={`${isDark ? 'text-gray-200' : 'text-gray-700'} text-xs font-semibold`}>Total Marked</h1>
										<p className="text-lg font-bold text-blue-700">30</p>
									</div>
								</div>
							</div>
							<div className={`${isDark ? 'bg-green-900' : 'bg-green-100'} flex items-center justify-between p-4 w-full md:w-1/4 rounded-xl shadow-lg`}>
								<div className="flex items-center gap-3">
									<img src={PresentImage} alt="members" className="w-16 h-11" />
									<div>
										<h1 className={`${isDark ? 'text-gray-200' : 'text-gray-700'} text-xs font-semibold`}>Present</h1>
										<p className="text-lg font-bold text-green-700">25</p>
									</div>
								</div>
							</div>
							<div className={`${isDark ? 'bg-red-900' : 'bg-red-100'} flex items-center justify-between p-4 w-full md:w-1/4 rounded-xl shadow-lg`}>
								<div className="flex items-center gap-3">
									<img src={AbsentImage} alt="members" className="w-14 h-11" />
									<div>
										<h1 className={`${isDark ? 'text-gray-200' : 'text-gray-700'} text-xs font-semibold`}>Absent</h1>
										<p className="text-lg font-bold text-red-700">5</p>
									</div>
								</div>
							</div>
							<div className={`${isDark ? 'bg-yellow-900' : 'bg-yellow-100'} flex items-center justify-between p-4 w-full md:w-1/4 rounded-xl shadow-lg`}>
								<div className="flex items-center gap-3">
									<img src={ClockImage} alt="members" className="w-12 h-11" />
									<div>
										<h1 className={`${isDark ? 'text-gray-200' : 'text-gray-700'} text-xs font-semibold`}>Late</h1>
										<p className="text-lg font-bold text-yellow-700">0</p>
									</div>
								</div>
							</div>
						</div>

						<div className="mt-10">
							<div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
								<div className="flex gap-3 items-center">
									<img src={GenderImage} alt="" className="w-10 h-10 rounded-full" />
									<h1 className="text-gray-300 text-sm font-bold mt-2">Gender-based Attendance</h1>
								</div>
								<div className="mt-1">
									<p className="bg-white rounded-xl p-1 font-semibold text-xs">
										<span className="text-blue-600 font-bold">9</span> males/ <span className="text-pink-700 font-bold">21</span> females
									</p>
								</div>
							</div>

							<div className="flex flex-col md:flex-row gap-3">
								<div className="bg-blue-100 p-2 mt-6 w-full md:w-1/2 rounded-xl">
									<div className=" flex justify-between">
										<div className="flex gap-3">
											<img src={MaleImage} alt="" className="w-10 h-10 mt-5 rounded-full" />
											<div>
												<h1 className="text-gray-700 font-bold mt-6">Male Attendance</h1>
												<p className="text-xs text-gray-400">Attendance statistics for male members</p>
											</div>
										</div>
										<h1 className="bg-white rounded-full h-10 mt-5 p-2 text-blue-700 font-bold">9</h1>
									</div>
									<div className="mt-5 ml-14">
										<div className="flex justify-between">
											<h1 className="text-gray-700 text-sm font-bold">Present</h1>
											<div className="flex gap-5">
												<h1 className="text-green-900 text-xs font-bold">8</h1>
												<p className="text-green-700 text-xs font-semibold">89%</p>
											</div>
										</div>
										<div className="bg-white w-full  rounded-xl">
											<div className="bg-green-700 p-1 w-56 rounded-xl mt-3 "></div>
										</div>
									</div>
									<div className="mt-5 ml-14">
										<div className="flex justify-between">
											<h1 className="text-gray-700 text-sm font-bold">Absent</h1>
											<div className="flex gap-5">
												<h1 className="text-red-600 text-xs font-bold">1</h1>
												<p className="text-red-700 text-xs font-semibold">11%</p>
											</div>
										</div>
										<div className="bg-white w-full  rounded-xl">
											<div className="bg-red-500 p-1 w-6 rounded-xl mt-3 "></div>
										</div>
									</div>
									<div className="mt-5 ml-14">
										<div className="flex justify-between">
											<h1 className="text-gray-700 text-sm font-bold">Late</h1>
											<div className="flex gap-5">
												<h1 className="text-orange-600 text-xs font-bold">0</h1>
												<p className="text-orange-500 text-xs font-semibold">0%</p>
											</div>
										</div>
										<div className="bg-white w-full  rounded-xl">
											<div className="bg-orange-500 p-1 w-0 rounded-xl mt-3 "></div>
										</div>
									</div>
							</div>
							<div className="bg-pink-100 p-2 mt-6 w-full md:w-1/2 rounded-xl">
								<div className=" flex justify-between">
									<div className="flex gap-3">
										<img src={WomenImage} alt="" className="w-10 h-10 mt-5 rounded-full" />
										<div>
											<h1 className="text-gray-700 font-bold mt-6">Female Attendance</h1>
											<p className="text-xs text-gray-400">Attendance statistics for female members</p>
										</div>
									</div>
									<h1 className="bg-white rounded-full h-10 mt-5 p-2 text-pink-700 font-bold">21</h1>
								</div>
								<div className="mt-5 ml-14">
									<div className="flex justify-between">
										<h1 className="text-gray-700 text-sm font-bold">Present</h1>
										<div className="flex gap-5">
											<h1 className="text-green-900 text-xs font-bold">17</h1>
											<p className="text-green-700 text-xs font-semibold">81%</p>
										</div>
									</div>
									<div className="bg-white w-full  rounded-xl">
										<div className="bg-green-700 p-1 w-52 rounded-xl mt-3 "></div>
									</div>
								</div>
								<div className="mt-5 ml-14">
									<div className="flex justify-between">
										<h1 className="text-gray-700 text-sm font-bold">Absent</h1>
										<div className="flex gap-5">
											<h1 className="text-red-600 text-xs font-bold">4</h1>
											<p className="text-red-700 text-xs font-semibold">19%</p>
										</div>
									</div>
									<div className="bg-white w-full  rounded-xl">
										<div className="bg-red-500 p-1 w-14 rounded-xl mt-3 "></div>
									</div>
								</div>
								<div className="mt-5 ml-14">
									<div className="flex justify-between">
										<h1 className="text-gray-700 text-sm font-bold">Late</h1>
										<div className="flex gap-5">
											<h1 className="text-orange-600 text-xs font-bold">0</h1>
											<p className="text-orange-500 text-xs font-semibold">0%</p>
										</div>
									</div>
									<div className="bg-white w-full  rounded-xl">
										<div className="bg-orange-500 p-1 w-0 rounded-xl mt-3 "></div>
									</div>
								</div>
							</div>
						</div>
					</div>
            </div>
            </div>
        </Layout>
  );
}

export default Attendance;
